import {
  BoldIcon,
  CodeIcon,
  CrossReferenceIcon,
  HeadingIcon,
  ItalicIcon,
  LinkIcon,
  ListOrderedIcon,
  ListUnorderedIcon,
  MentionIcon,
  QuoteIcon,
  TasklistIcon,
} from '@primer/octicons-react'
import {ActionBar} from '@primer/react'
import type React from 'react'
import {memo} from 'react'

import {SavedRepliesButton} from './SavedReplies'
import styles from './Toolbar.module.css'
import {CommandToolbarButton} from './ToolbarButton'

export const DefaultToolbarButtons = memo(() => {
  return (
    <>
      <CommandToolbarButton commandId="markdown-editor:insert-heading" icon={HeadingIcon} />
      <CommandToolbarButton commandId="markdown-editor:toggle-bold" icon={BoldIcon} />
      <CommandToolbarButton commandId="markdown-editor:toggle-italic" icon={ItalicIcon} />
      <CommandToolbarButton commandId="markdown-editor:insert-blockquote" icon={QuoteIcon} />
      <CommandToolbarButton commandId="markdown-editor:insert-code" icon={CodeIcon} />
      <CommandToolbarButton commandId="markdown-editor:insert-link" icon={LinkIcon} />

      <ActionBar.Group>
        <ActionBar.Divider />

        <CommandToolbarButton commandId="markdown-editor:insert-unordered-list" icon={ListUnorderedIcon} />
        <CommandToolbarButton commandId="markdown-editor:insert-ordered-list" icon={ListOrderedIcon} />
        <CommandToolbarButton commandId="markdown-editor:insert-task-list" icon={TasklistIcon} />
      </ActionBar.Group>

      <ActionBar.Group>
        <ActionBar.Divider />

        <CommandToolbarButton commandId="markdown-editor:insert-mention" icon={MentionIcon} />
        <CommandToolbarButton commandId="markdown-editor:insert-reference" icon={CrossReferenceIcon} />
      </ActionBar.Group>
    </>
  )
})
DefaultToolbarButtons.displayName = 'MarkdownEditor.DefaultToolbarButtons'

export const CoreToolbar = ({children}: {children?: React.ReactNode}) => {
  return (
    <div className={styles.toolbar}>
      <ActionBar aria-label="Formatting tools" className={styles.actionBar} gap="none">
        {children}
      </ActionBar>

      <SavedRepliesButton />
    </div>
  )
}

export const Toolbar = ({children}: {children?: React.ReactNode}) => <CoreToolbar>{children}</CoreToolbar>
Toolbar.displayName = 'MarkdownEditor.Toolbar'
